import {lazy} from 'react';
import BasicLayout from '@/layouts/BasicLayout';
import AuthorLayout from '@/layouts/AuthorLayout';
import MiniBasicLayout from '@/layouts/MiniBasicLayout';
import NotFound from '@/pages/Exception/404';

const Home = lazy(() => import('@/pages/Home'));
const Cover = lazy(() => import('@/pages/Cover'));
const Read = lazy(() => import('@/pages/Read'));
const Recharge = lazy(() => import('@/pages/Recharge'));
const Regist = lazy(() => import('@/pages/Regist'));
const LoginSuccess = lazy(() => import('@/pages/LoginSuccess'));
const My = lazy(() => import('@/pages/My'));
const Classify = lazy(() => import('@/pages/Classify'));
const Copyright = lazy(() => import('@/pages/Copyright'));
const AudioCopyright = lazy(() => import('@/pages/AudioCopyright'));
const Search = lazy(() => import('@/pages/Search'));
const Author = lazy(() => import('@/pages/Author'));
const AuthorBookList = lazy(() => import('@/pages/Author/Book/Lists'));
const AuthorBookCreate = lazy(() => import('@/pages/Author/Book/Create'));
const AuthorChapterDraft = lazy(() => import('@/pages/Author/Chapter/Draft'));
const AuthorBookEdit = lazy(() => import('@/pages/Author/Book/Edit'));
const AuthorLogin = lazy(() => import('@/pages/Author/Login/Index'));
const AuthorPerson = lazy(() => import('@/pages/Author/Person/Index'));

const routes = [
  {
    path:'/',
    redirect:'',
    layout:BasicLayout,
    component:Home,
    auth: false
  },
  {
    path:'/copyright',
    redirect:'',
    layout:BasicLayout,
    component:Copyright,
    auth: false
  },
  {
    path:'/audiocopyright',
    redirect:'',
    layout:BasicLayout,
    component:AudioCopyright,
    auth: false
  },
  {
    path:'/classify',
    redirect:'',
    layout:BasicLayout,
    component:Classify,
    auth: false
  },
  {
    path:'/book/:aid',
    redirect:'',
    layout:BasicLayout,
    component:Cover,
    auth: false
  },
  {
    path:'/read/:aid/:cid',
    redirect:'',
    component:Read,
    auth: false
  },
  {
    path:'/recharge',
    redirect:'',
    component:Recharge,
    auth: true
  },
  {
    path:'/regist',
    redirect:'',
    layout:MiniBasicLayout,
    component:Regist,
    auth: false
  },
  {
    path:'/my/:type',
    redirect:'',
    layout:BasicLayout,
    component:My,
    auth: true
  },
  {
    path:'/search/:keyword',
    redirect:'',
    layout:BasicLayout,
    component:Search,
    auth: false
  },
  {
    path:'/author/person',
    redirect:'',
    layout:AuthorLayout,
    component:AuthorPerson,
    auth: false
  },
  {
    path:'/author/book/lists',
    redirect:'',
    layout:AuthorLayout,
    component:AuthorBookList,
    auth: false
  },
  {
    path:'/author/book/create',
    redirect:'',
    layout:AuthorLayout,
    component:AuthorBookCreate,
    auth: false
  },
  {
    path:'/author/login',
    redirect:'',
    layout:BasicLayout,
    component:AuthorLogin,
    auth: false
  },
  {
    path:'/author/book/articleid/:aid',
    redirect:'',
    layout:AuthorLayout,
    component:AuthorBookEdit,
    auth: false
  },
  {
    path:'/author/book/draft/:aid',
    redirect:'',
    layout:BasicLayout,
    component:AuthorChapterDraft,
    auth: false
  }
]

export default routes;